import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    brand: {
      100: "rgba(73, 42, 119, 1)",
    },
  },
});

export default theme;
